export default "__VITE_ASSET__6e3a7820__"